var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_7024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_7024",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_7024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 24.9993C19.1603 24.9993 18.3003 24.7793 17.6303 24.3493L11.6103 20.4193C10.4903 19.6893 9.82031 18.4593 9.82031 17.1193C9.82031 15.7793 10.4903 14.5493 11.6103 13.8193L17.6403 9.8993C18.9803 9.0293 21.0703 9.0293 22.4003 9.9093L28.3903 13.8393C29.5003 14.5693 30.1703 15.7993 30.1703 17.1293C30.1703 18.4593 29.5003 19.6893 28.3903 20.4193L22.4003 24.3493C21.7303 24.7893 20.8703 24.9993 20.0103 24.9993ZM20.0103 10.7493C19.4403 10.7493 18.8703 10.8793 18.4603 11.1593L12.4403 15.0793C11.7403 15.5393 11.3303 16.2793 11.3303 17.1193C11.3303 17.9593 11.7303 18.6993 12.4403 19.1593L18.4603 23.0893C19.2903 23.6293 20.7503 23.6293 21.5803 23.0893L27.5703 19.1593C28.2703 18.6993 28.6703 17.9593 28.6703 17.1193C28.6703 16.2793 28.2703 15.5393 27.5703 15.0793L21.5803 11.1493C21.1603 10.8893 20.5903 10.7493 20.0103 10.7493Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 30.7501C19.5611 30.7501 19.1111 30.6901 18.7511 30.5701L15.5612 29.5101C14.0512 29.0101 12.8612 27.3601 12.8712 25.7701L12.8812 21.0801C12.8812 20.6701 13.2212 20.3301 13.6312 20.3301C14.0412 20.3301 14.3812 20.6701 14.3812 21.0801L14.3712 25.7701C14.3712 26.7101 15.1512 27.7901 16.0412 28.0901L19.2311 29.1501C19.6311 29.2801 20.3711 29.2801 20.7711 29.1501L23.9611 28.0901C24.8511 27.7901 25.6311 26.7101 25.6311 25.7801V21.1401C25.6311 20.7301 25.9711 20.3901 26.3811 20.3901C26.7911 20.3901 27.1311 20.7301 27.1311 21.1401V25.7801C27.1311 27.3701 25.9511 29.0101 24.4411 29.5201L21.2511 30.5801C20.8911 30.6901 20.4411 30.7501 20.0011 30.7501Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3984 23.75C28.9884 23.75 28.6484 23.41 28.6484 23V17C28.6484 16.59 28.9884 16.25 29.3984 16.25C29.8084 16.25 30.1484 16.59 30.1484 17V23C30.1484 23.41 29.8084 23.75 29.3984 23.75Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_7024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapIcon);
export default __webpack_public_path__ + "static/media/cap-icon.1a0b4fbdb97c1004dab87d01b068550e.svg";
export { ForwardRef as ReactComponent };